import { AnyAccountJwtVO, IAMAccountJwtVO, KeycloakAccountJwtVO } from "../vo";

export class AnyAccountJwtVOSpecs {
  static cmp(lhs?: null | AnyAccountJwtVO, rhs?: null | AnyAccountJwtVO) {
    return (
      lhs?.value.id === rhs?.value.id && lhs?.value.method === rhs?.value.method
    );
  }

  static isIdentityAccountJwtVO(
    accountJwt?: null | AnyAccountJwtVO
  ): accountJwt is IAMAccountJwtVO | KeycloakAccountJwtVO {
    return (
      accountJwt instanceof IAMAccountJwtVO ||
      accountJwt instanceof KeycloakAccountJwtVO
    );
  }
}
